import React, { useEffect, useState } from "react";
import api, { apiErrorMessage } from "@/lib/api";
import { ADMIN_TRAIN } from "@/constants/testIds";

export default function AdminCertifications() {
  const [certs, setCerts] = useState([]);
  const [err, setErr] = useState("");

  const reload = async () => {
    try { const { data } = await api.get("/admin/training/certifications"); setCerts(data); }
    catch (e) { setErr(apiErrorMessage(e)); }
  };
  useEffect(() => { reload(); }, []);

  const revoke = async (id) => {
    if (!window.confirm("Revoke this certificate? Public verification will mark it as REVOKED.")) return;
    await api.post(`/admin/training/certifications/${id}/revoke`);
    await reload();
  };

  return (
    <div className="space-y-6">
      <header className="fade-up">
        <div className="eyebrow">Training admin</div>
        <h1 className="headline-xl">Certifications</h1>
      </header>
      {err && <div className="text-rose-300 text-sm">{err}</div>}
      <div data-testid={ADMIN_TRAIN.certsList} className="glass-panel overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-[0.7rem] tracking-[0.22em] uppercase text-lifted-mute font-bebas border-b border-white/5">
              <th className="px-4 py-3">Code</th>
              <th className="px-4 py-3">User</th>
              <th className="px-4 py-3">Track</th>
              <th className="px-4 py-3">Score</th>
              <th className="px-4 py-3">Issued</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3 text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {certs.map((c) => (
              <tr key={c.id} className="border-b border-white/5">
                <td className="px-4 py-3"><code className="text-lifted-green text-xs">{c.verification_code}</code></td>
                <td className="px-4 py-3 text-xs text-lifted-dim">{c.user_id}</td>
                <td className="px-4 py-3"><span className="chip">{c.track_key}</span></td>
                <td className="px-4 py-3 font-anton text-lifted-green">{c.score}</td>
                <td className="px-4 py-3 text-xs text-lifted-dim">{c.issued_at}</td>
                <td className="px-4 py-3">
                  {c.revoked
                    ? <span className="chip" style={{ background: "rgba(244,63,94,.15)", color: "#fca5a5" }}>Revoked</span>
                    : <span className="chip chip--green">Valid</span>}
                </td>
                <td className="px-4 py-3 text-right">
                  {!c.revoked && (
                    <button data-testid={ADMIN_TRAIN.certRevoke(c.id)} onClick={() => revoke(c.id)} className="btn-ghost !py-1.5 !px-3 !text-[0.65rem] hover:!text-rose-300">Revoke</button>
                  )}
                </td>
              </tr>
            ))}
            {certs.length === 0 && <tr><td colSpan={7} className="px-4 py-10 text-center text-lifted-mute">No certificates issued yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
